import type { IMessage, EMessageChannel } from 'src/services/api/messages/types';

/**
 * Work out where a conversation moved from one channel to another, so the thread
 * can call out the switch (e.g. Facebook Messenger -> Text Message once we
 * collected a phone number).
 *
 * Returns an array aligned with `messages`: for each message, the channel it
 * switched to, or null when it continues on the channel already in use. The
 * first real message is never a switch — there is nothing to switch from.
 *
 * System messages (tour updates, calls, ...) are ignored: they carry a channel
 * that does not reflect how we actually reached the lead.
 */
export function computeChannelSwitches(messages: IMessage[]): (EMessageChannel | null)[] {
    let previousChannel: EMessageChannel | undefined;

    return messages.map((message) => {
        if (message.system_message_type) {
            return null;
        }

        const isSwitch = previousChannel !== undefined && message.channel !== previousChannel;
        previousChannel = message.channel;

        return isSwitch ? message.channel : null;
    });
}
